module.exports = __webpack_public_path__ + "2c6c9ca381e2c6100c25f9c7381314b0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-savannah.png
// module id = 3648
// module chunks = 0